import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { map } from 'lodash';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { FieldTypeListMultipleComponent } from '../field-type-list/field-type-list-multiple/field-type-list-multiple.component';
import { FieldTypeListExtendedComponent } from '../field-type-list-extended/field-type-list-extended.component';
import { FieldTypeContactsComponent } from '@shared/components/field-type-contacts/field-type-contacts.component';
import { FormsModule } from '@angular/forms';
import { WizardStepsComponent } from '../wizard-steps/wizard-steps.component';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { FieldTypeRichTextEditableComponent } from '../field-type-rich-text/field-type-rich-text-editable/field-type-rich-text-editable.component';

@Component({
  selector: 'share-instance',
  templateUrl: './share-instance.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective,
    NgClass,
    WizardStepsComponent,
    FormsModule,
    FieldTypeContactsComponent,
    FieldTypeListExtendedComponent,
    FieldTypeListMultipleComponent,
    FieldTypeRichTextEditableComponent
  ]
})
export class ShareInstanceComponent implements OnInit {
  concept: any = this.dialogConfig.data.concept;
  from: any = this.dialogConfig.data.from;
  shareInstance: any = {
    buttonAccept: this.translate.instant('common.continue'),
    shareTitle: this.translate.instant('share-instance.question-title'),
    title: this.translate.instant('concept-tab.share-concept'),
    contactsType: 'share-instance',
    optionSelect: 'evaluation',
    message: '',
    step: 1,
    showText: true,
    fieldRich: {
      label: this.translate.instant('common.comment'),
      required: false,
      relatedInfo: [],
      noEditable: false,
      isEditable: true,
      fieldTypeId: 'rich'
    },
     shareTypeDocumentField: {
      multiple: false,
      required: true,
      type: 'modal',
      label: this.translate.instant('share-document.type-share-label')
    },
    shareDocumentationField: {
      label: this.translate.instant('share-document.restricted-select'),
      multiple: true,
      required: true,
    },
    shareInstanceContact: {
      label: this.from==='knowledge'?this.translate.instant('common.users-contacts'):this.translate.instant('contacts.contacts'),
      fieldId: 'share-instance-contact',
      typeConfiguration: this.from==='knowledge'?'share-field':'share-instance',
      multiple: true,
      addContacts: Boolean(this.concept.productId !== "aml002"),
      required: true,
      typeCall: this.from==='knowledge'?'contacts-users-only':'contacts-only',
      callEvaluationTaskShares: this.from==='knowledge'?false:true,
      selectContacts: []
    }
  }
  constructor(private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private broadcastService: BroadcastService,
    private dialogRef: DynamicDialogRef<ShareInstanceComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.configureShareFieldContainer();
    this.shareInstance.queryProduct = Boolean(this.concept.productId === "aml002")
    if(this.from==='knowledge'){
      this.configureShareKnowledgeField();
    }else if(this.from ==='concept' && this.concept?.hasOpenEvaluationTask){
      this.shareInstance.existingTask = true;
      this.shareInstance.optionSelect = 'query';
      this.hasEvaluationTaskRepeat();
    }
  }

  hasEvaluationTaskRepeat(){
    this.apiService.get('conceptobjects/'+this.concept.conceptObjectId+'/has-active-repeat-pattern/task-type','evaluation')
    .then((data:any)=>{
      let text:string = data.hasActiveRepeatPattern? 'share-instance.has-repeat' : 'concept-tab.share-concept-no-create';
      this.shareInstance.evaluationErrorMessage = this.translate.instant(text)
    }, (errorData:any)=>{})
  }

  configureShareKnowledgeField(){
    this.shareInstance.step = 2;
    this.shareInstance.shareTitle = this.translate.instant('share-instance.share-field-info');
    this.shareInstance.title = this.translate.instant('share-instance.share-field-title');
    this.shareInstance.shareInstanceContact.selectContactsType = "share-field";
  }

  onQueryShare() {
    this.shareInstance.step = 2;
    this.shareInstance.shareTitle = this.translate.instant('share-instance.share-concept-info');
  }

  shareQuery() {
    this.shareInstance.shareInstanceContact.selectContacts && this.shareInstance.shareInstanceContact.selectContacts.length
      ? this.handleAccept('query')
      : this.shareInstance.shareInstanceContact.error = true;
  }

  receiveContacts(contacts:any){
    this.shareInstance.shareInstanceContact.selectContacts = contacts;
    this.shareInstance.shareInstanceContact.error = !!(contacts.length);
  }

  contactsClosed() {
    this.shareInstance.showText = !this.shareInstance.showText;
  }

  getdestinations(){
    if(this.shareInstance.shareInstanceContact.selectContacts){
      let contacts:any = [];
      this.shareInstance.shareInstanceContact.selectContacts.forEach((contact:any) => {
        let id: string = contact.contactId? 'contactId' : 'userId';
        contacts.push({
          [id]: contact[id]
        });
      });
      let shared:any = {
        persons: contacts,
        comments: this.shareInstance.message
      }
      return shared;
    }
  }

  knowledgeDestination(){
    let contacts:any = [];
    this.shareInstance.shareInstanceContact.selectContacts.forEach((contact:any) => {
      let id: string = contact.contactId? 'contactId' : 'userId';
      contacts.push({
        [id]: contact[id],
        comment: this.shareInstance.message
      });
    });
    return contacts;
  }

  configureShared(){
    if(this.shareInstance.optionSelect==='query'){
      return this.getConceptShares();
    }else{
      return this.from ==='knowledge'? this.knowledgeDestination() : this.getdestinations();
    }
  }

  nextStep(){
    if(this.shareInstance.shareInstanceContact.selectContacts.length){
      this.shareInstance.wizardState = 2;
      this.shareInstance.shareTitle = this.translate.instant('share-document.share-info-document')
    }else{
      this.shareInstance.shareInstanceContact.error = true;
    }
  }

  validateKnowledge() {
    if (this.shareInstance.shareInstanceContact.selectContacts.length) {
      this.handleAccept('knowledge');
    } else {
      this.shareInstance.shareInstanceContact.error = true;
    }
  }

  backStep(){
    this.shareInstance.wizardState = 1;
    this.shareInstance.shareTitle = this.translate.instant('share-instance.share-concept-info');
  }

  resetItems(){
    if(this.shareInstance.wizardState === 1){
      this.broadcastService.broadcast('resetFieldContact', {field: this.shareInstance.shareInstanceContact});
    }else{
      this.shareInstance.shareInstanceContact.selectContacts = [];
      this.shareInstance.wizardState = 1;
    }
    this.shareInstance.message = '';
    this.shareInstance.shareDocumentationListSelected = '';
    this.shareInstance.typeShareDocumentSelected='0';
  }

  configureShareFieldContainer(){
    this.shareInstance.wizardState = 1;
    this.shareInstance.shareDocumentationListSelected = '';
    this.shareInstance.typeShareDocumentSelected='0'
    this.shareInstance.steps = [{
        name:this.translate.instant('task-list.addressee'),
        noEditable:false
      },{
        name:this.translate.instant('common.documentation'),
        noEditable:false
    }]

    this.shareInstance.typeShareDocument = [
      {
        listValueId:'0',
        text: this.translate.instant('share-document.no-share-documents')
      },{
        listValueId:'1',
        text: this.translate.instant('share-document.share-all-documents')
      },{
        listValueId:'2',
        text: this.translate.instant('share-document.share-selected-documents')
      }
    ]

    this.apiService.get('documentobjects/allfilesids', this.concept.conceptObjectId)
      .then((data:any)=>{
        this.shareInstance.shareDocumentationList = this.commonUtilsService.editList(data, 'documentObjectId', 'name');
      })
  }

  selectSharedDocumentation(e:any){
    this.shareInstance.shareDocumentationListSelected = e.newValue;
  }

  getConceptShares() {
    let shares:any = {
      comments:  this.shareInstance.message,
      persons: map( this.shareInstance.shareInstanceContact.selectContacts, this.mapDestination)
    };

    shares.documentsShareType = parseInt(this.shareInstance.typeShareDocumentSelected);
    if(shares.documentsShareType === 2){
      shares.documentObjects = this.extractDocumentObjects()
    }

    return shares;
  }

  mapDestination(destination:any) {
    let mapped:any = {};
    if (destination.groupId) {
      mapped.groupId = destination.groupId;
    } else if (destination.userId){
      mapped.userId = destination.userId;
    } else if (destination.contactId){
      mapped.contactId = destination.contactId;
    } else if (destination.productRoleId){
      mapped.productRoleId = destination.productRoleId;
    }
    return mapped;
  }

  checkOptions(){
    this.shareInstance.shareDocumentationField.error = false;
    if (this.shareInstance.typeShareDocumentSelected !== '2'  || (this.shareInstance.typeShareDocumentSelected === '2' && this.shareInstance.shareDocumentationListSelected !== '')) {
      this.handleAccept('query')
    } else {
      if (this.shareInstance.shareDocumentationListSelected === '') {
        this.shareInstance.shareDocumentationField.error = true;
      }
    }
  }

  extractDocumentObjects(){
    let arrayDocuments:any = [];
    let documentsSelected: any = this.shareInstance.shareDocumentationListSelected.indexOf('|') === -1? [this.shareInstance.shareDocumentationListSelected] : this.shareInstance.shareDocumentationListSelected.split('|');
    documentsSelected.forEach((document:any)=>{
      arrayDocuments.push(parseInt(document))
    })
    return arrayDocuments;
  }

  handleAccept(optionSelected: string) {
    this.dialogRef.close({
      result: 'ok',
      option: optionSelected,
      shared: this.configureShared()
    });
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }

}
